const Measure = (_options, _add) => {
  try {
    setTimeout(() => {
      let addstr = '';
      if (_add){
        const keys = Object.keys(_add);
        for (let i = 0; i < keys.length; i += 1){
          addstr += `${keys[i] }="${_add[keys[i]]}";`;
        }
        addstr = `<script>${addstr}</script>`;
      }

      const html = `
        <html>
        <head>
          <script>_isIframe = true;</script>+
          <script>
            var trace_p="${_options.pageName}";
          </script>
          ${addstr}
          <script src="//assets.adobedtm.com/2f06117c403b/c46275b6c025/launch-b3cf403ba24a.min.js"></script>
          <title>${_options.title}</title>
        </head>
        <body>
          <script language="javascript">s = new Object(); _satellite.pageBottom();</script>
          <script src="/sol/contents/common/js/jquery-3.5.1.min.js"></script>
          <div id="_load_web_cl_promo"></div>
          <script src="/sol/contents/common/js/kobetu/web_cl_promo.js"></script>
          <!-- YTMタグ用 変数 -->
          <script type="text/javascript">
            var _fsnIsLogin = typeof(_fsnIsLogin) !== 'undefined' ? _fsnIsLogin : 0;
            var _fsnIsNinteimaeLogin = typeof(_fsnIsNinteimaeLogin) !== 'undefined' ? _fsnIsNinteimaeLogin : 0;
          </script>
          <!-- /YTMタグ用 変数 -->
          <!-- YTMタグ -->
          <script type="text/javascript">
            (function () {
              var tagjs = document.createElement("script");
              var s = document.getElementsByTagName("script")[0];
              tagjs.async = true;
              tagjs.src = "//s.yjtag.jp/tag.js#site=n8e9a7K,6o2mO3c,ORUiWYO,97V6Gcv,SzruuAF,VYpw1yt,mHpUtXe,gWKXnFn&referrer=" + encodeURIComponent(document.location.href) + "";
              s.parentNode.insertBefore(tagjs, s);
            }());
          </script>
          <noscript>
            <iframe src="//b.yjtag.jp/iframe?c=n8e9a7K,6o2mO3c,ORUiWYO,97V6Gcv,SzruuAF,VYpw1yt,mHpUtXe,gWKXnFn" width="1" height="1" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
          </noscript>
          <!-- YTM -->
          <script language="javascript">_satellite.pageBottom();</script>
        </body>
        </html>`;
      try{
        const elm = document.getElementById('_sc_iframe');
        elm.parentNode.removeChild(elm);
      } catch(e){
        console.log({ e });
      }

      const iframeElm = document.createElement('iframe');
      iframeElm.style.width = 0;
      iframeElm.style.height = 0;
      iframeElm.id = '_sc_iframe';
      document.body.appendChild(iframeElm);
      const doc = iframeElm.contentDocument;
      doc.open();
      doc.writeln(html);
      doc.close();
    }, 500);
  } catch(e) {
    console.log({ e });
  }
};

export default Measure;